import { styled } from "@mui/material";

const CardDiv = styled("div")`
  background: ${({ theme }) => theme.cards.primary};
  border-radius: 15px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  text-align: center;
  box-shadow: ${({ theme }) => theme.cards.shadows};
  opacity: 1;
`;

const Card = ({ children, ...otherProps }) => {
  return <CardDiv {...otherProps}>{children}</CardDiv>;
};

export default Card;
